<template>
<div>
  <v-layout row="" wrap="">
    <v-text-field prefix="₺" readonly hide-details label="Satış Tutar:" v-model="Rez.toplamTL.satis"></v-text-field>
    <v-text-field prefix="₺" readonly hide-details label="Maliyet:" v-model="Rez.toplamTL.alis"></v-text-field>
    <v-text-field prefix="₺" readonly hide-details label="Iskonto:" v-model="Rez.toplamTL.iskonto"></v-text-field>
    <v-text-field prefix="₺" readonly hide-details label="Komisyon:" v-model="Rez.toplamTL.komisyon"></v-text-field>
    <v-text-field prefix="₺" readonly hide-details label="Net Satış:" :value="(Rez.toplamTL.satis - Rez.toplamTL.iskonto)"></v-text-field>
  </v-layout>
  <br>

  <datatable :tableheaders="tableheaders" :tableitems="Rez.odemeler" v-on:edititem="edititem" v-on:insertitem="insertitem" v-on:deleteitem="deleteitem" :item="item" :status="status" hide-actions class="elevation-1">
    <template slot="dialogmain" slot-scope="prop">

        <v-text-field type="date" hide-details label="Ödeme Tarihi"   v-model="prop.item.tarih"></v-text-field>
        <kur v-model="prop.item.para" :kurtarihi="prop.item.tarih"></kur>
        <v-text-field hide-details label="dovizTutar"   v-model="prop.item.dovizTutar"></v-text-field>
        <v-select hide-details label="evrakTipi" v-model="prop.item.evrakTipi"
        :items="['NK','KR','HV','SP','NKI','KRI','HVI','SPI']"
        ></v-select>

        <v-text-field hide-details label="evrakNo"   v-model="prop.item.evrakNo"></v-text-field>
        <v-text-field hide-details label="kartNo"   v-model="prop.item.kartNo"></v-text-field>
        <v-text-field hide-details label="kartBanka"   v-model="prop.item.kartBanka"></v-text-field>
        <v-text-field hide-details label="kartTip"   v-model="prop.item.kartTip"></v-text-field>
        <v-text-field hide-details label="kartTaksit"   v-model="prop.item.kartTaksit"></v-text-field>

        <v-text-field hide-details label="kartAdi"   v-model="prop.item.kartAdi"></v-text-field>
        <v-text-field hide-details label="hvBankaKod"   v-model="prop.item.hvBankaKod"></v-text-field>
        <v-text-field hide-details label="hvAciklama"   v-model="prop.item.hvAciklama"></v-text-field>
        <!--
          <v-text-field hide-details label="silinecek"   v-model="prop.item.silinecek"></v-text-field>
          <v-text-field hide-details label="mevcutOdeme"   v-model="prop.item.mevcutOdeme"></v-text-field>
          <v-text-field hide-details label="yuzde"   v-model="prop.item.yuzde"></v-text-field>
          <v-text-field hide-details label="iskonto"   v-model="prop.item.iskonto"></v-text-field>
          <v-text-field hide-details label="hedefParaTutar"   v-model="prop.item.hedefParaTutar"></v-text-field>
          <v-text-field hide-details label="siraNo"   v-model="prop.item.siraNo"></v-text-field>
          <v-text-field hide-details label="sirketAdi"   v-model="prop.item.sirketAdi"></v-text-field>
          <v-text-field hide-details label="hesapKodu"   v-model="prop.item.hesapKodu"></v-text-field>
          <v-text-field hide-details label="paraBirimi"   v-model="prop.item.paraBirimi"></v-text-field>
          <v-text-field hide-details label="dovizKur"   v-model="prop.item.dovizKur"></v-text-field>
        

        -->

      

    </template>
  </datatable>

</div>
</template>

<script>
import tool from "../tools";
import datatable from "@/components/app/coper/comp/datatable.vue";
import kur from "@/components/app/coper/comp/kur.vue";


export default {
  props: ["value"],

  computed: {
    Rez: {
      get: function () {

        return this.value;
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      },
    },
  },

  data() {
    return {
      status: tool.NewSatatus(),
      item: {
        tarih:tool.Now_yyyy_MM_dd(),
        evrakTipi:'NK',
        para:{kur:1,paraBirimi:'TL',kurTarihi:tool.Now_yyyy_MM_dd() }
      },
      tableheaders: [{
          text: 'evrakNo',
          value: 'evrakNo',
          sortable: false
        },

        {
          text: 'evrakTipi',
          value: 'evrakTipi',
          sortable: false
        },

        {
          text: 'tarih',
          value: 'tarih',
          sortable: false
        },

        {
          text: 'paraBirimi',
          value: 'para',
          value2: 'paraBirimi',
          sortable: false
        },

        {
          text: 'dovizTutar',
          value: 'dovizTutar',
          sortable: false
        },

        {
          text: 'dovizKur',
          value: 'para',
          value2: 'kur',
          
          sortable: false
        },

        {
          text: 'işlemler',
          value: 'islemsutunu',
          sortable: false
        }

      ],

    }
  },

  components: {
    datatable,
    kur,
  },

  watch: {

  },
  methods: {
    edititem: edititem,
    insertitem: insertitem,
    deleteitem: deleteitem,

    GenelOdemeSil: GenelOdemeSil,
    GetOdeme: GetOdeme,
    OdemeKaydet: OdemeKaydet,
    OdemeGuncelle: OdemeGuncelle,
    GenelOdemeSilveKaydet:GenelOdemeSilveKaydet,
    

  }
}

function edititem(val) {
  var i = this.Rez.odemeler.findIndex(k => k.siraNo == val.siraNo);
  //Object.assign(this.Rez.odemeler[i], val);
  this.OdemeGuncelle(val,this.Rez.odemeler[i]);
}

function insertitem(val) {
  //this.kayitInsert(val);
  var prm = {

    P_OdemeTipi: 3, //3:odeme 4:Iade
    P_PNR_No: this.Rez.pNR_No,
    P_HesapKodu: this.Rez.cariKod.id,
    P_SirketAdi: 1,
    P_CoSirketNo: 1,
    P_Referans: this.Rez.pNR_No,

    P_CoKrediKartYuzde: val.yuzde,
    
    P_DovizCinsi: val.para.paraBirimi,
    P_Kur: val.para.kur,


    P_DovizTutar: val.dovizTutar,
    P_EvrakTipi: val.evrakTipi,
    P_EvrakNo: val.evrakNo,
    P_KrediKartNo: val.kartNo,
    P_CoKrediKartBanka: val.kartBanka,
    P_CoKrediKartTip: val.kartTip,
    P_CoKrediKartTaksit: val.kartTaksit,
    P_CoKrediKartKod: val.kartAdi,
    //P_Aciklama  :val. VZ + cxBE_PNR_No.Text + '/' + isimList;
    P_Aciklama: this.Rez.pNR_No,
    P_Tarih: val.tarih,
    P_Vade: val.tarih,
    P_bankakod: val.hVBankaKod,
    P_HvAciklama: val.hVAciklama,
    P_Karsiaciklama: val.hVAciklama,
    //P_Masraf  :val. FmyFiyat.PNR_MasrafMerkezi;
    //P_poskod:
    //P_Taksitposkod
    //P_puantutar
  }
  this.OdemeKaydet(prm);

}


function OdemeGuncelle(val,eski_val) {

    var prm = {

    P_OdemeTipi: 3, //3:odeme 4:Iade
    P_PNR_No: this.Rez.pNR_No,
    P_HesapKodu: this.Rez.cariKod.id,
    P_SirketAdi: 1,
    P_CoSirketNo: 1,
    P_Referans: this.Rez.pNR_No,

    P_CoKrediKartYuzde: val.yuzde,
    
    P_DovizCinsi: val.para.paraBirimi,
    P_Kur: val.para.kur,

    P_DovizTutar: val.dovizTutar,
    P_EvrakTipi: val.evrakTipi,
    P_EvrakNo: val.evrakNo,
    P_KrediKartNo: val.kartNo,
    P_CoKrediKartBanka: val.kartBanka,
    P_CoKrediKartTip: val.kartTip,
    P_CoKrediKartTaksit: val.kartTaksit,
    P_CoKrediKartKod: val.kartAdi,
    //P_Aciklama  :val. VZ + cxBE_PNR_No.Text + '/' + isimList;
    P_Aciklama: this.Rez.pNR_No,
    P_Tarih: val.tarih,
    P_Vade: val.tarih,
    P_bankakod: val.hVBankaKod,
    P_HvAciklama: val.hVAciklama,
    P_Karsiaciklama: val.hVAciklama,
    //P_Masraf  :val. FmyFiyat.PNR_MasrafMerkezi;
    //P_poskod:
    //P_Taksitposkod
    //P_puantutar
  }

  this.GenelOdemeSilveKaydet(eski_val,prm);


}



function deleteitem(val) {

  if (val.sirketAdi > 0) {
    this.GenelOdemeSil(val);
  } else {
    const index = this.Rez.odemeler.indexOf(val);
    this.Rez.odemeler.splice(index, 1);
  }
}

function OdemeKaydet(prm) {
  this.status.loading = true;

  tool.http_post(this, "OdemeKaydet", prm).then(
    response => {
      //this.status.loading = false;
      this.GetOdeme();
    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );
}

function GenelOdemeSil(val) {
  this.status.loading = true;
  var prm = {
    P_SirketAdi: val.sirketAdi,
    P_HesapKodu: val.hesapKodu,
    P_Tarih: val.tarih,
    P_SiraNo: val.siraNo
  }

  tool.http_post(this, "GenelOdemeSil", prm).then(
    response => {
      //this.status.loading = false;
      this.GetOdeme();
    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );
}

function GenelOdemeSilveKaydet(val,insertprm) {
  this.status.loading = true;
  var prm = {
    P_SirketAdi: val.sirketAdi,
    P_HesapKodu: val.hesapKodu,
    P_Tarih: val.tarih,
    P_SiraNo: val.siraNo
  }

  tool.http_post(this, "GenelOdemeSil", prm).then(
    response => {
      //this.status.loading = false;
      this.OdemeKaydet(insertprm);
    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );
}


function GetOdeme() {
  this.status.loading = true;
  var prm = {
    pNR_No: this.Rez.pNR_No,
    carikod: this.Rez.cariKod.kod,
    hedefParaBirimi: 'TL',
    hedefKur: 1,
  }

  tool.http_post(this, "GetOdeme", prm).then(
    response => {
      this.Rez.odemeler = response.body;
      this.status.loading = false;
    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );
}
</script>
